import React, {PureComponent} from 'react';
import {CasinoFilterInterface} from 'app/interfaces/stores/CasinoGamesStoreInterfaces';
import I18n from 'app/i18n';
import {ELEMENT_NOT_FOUND, CASINO_TAB_LOOTBOX} from 'app/utils/Consts';
import {SwiperSlide} from 'swiper/swiper-react';
import FilterGroup from 'app/components/pages/casino/FilterGroup';
import ParentsFilter from 'app/components/pages/casino/ParentsFilter';
import ButtonFavourite from './ButtonFavourite';
import SwiperCore from 'swiper';
import {getWidth} from 'app/utils/getWidth';
import {isDesktopSmall} from 'app/utils';
import {openCasinoMobileSheetPopup} from 'app/utils/modals/openCasinoMobileSheetPopup';

interface FilterGroupsProps {
    casinoFilters: CasinoFilterInterface[]
    selectedFilterGroupId: number
    onClick?: () => void
    showOnlyFavorite: boolean
    favoritesCount: number
    handleButtonFavouriteClick: () => void
}

const CLASS_END = 'reached-end';
const CLASS_BEGIN = 'reached-begin';
const CLASS_MIDDLE = 'reached-middle';

const isCasinoFiltersSheetBreakpoint = (): boolean => !isDesktopSmall();

export default class FilterGroups extends PureComponent<FilterGroupsProps> {
    state = {renderSlider: false};

    rootElement: React.RefObject<HTMLDivElement> = React.createRef();

    onCheckReached = (swiper: SwiperCore): void => {
        const el = this.rootElement.current;

        if (!el) {
            return;
        }

        if (swiper.isEnd) {
            el.classList.add(CLASS_END);
            el.classList.remove(CLASS_BEGIN, CLASS_MIDDLE);
        } else if (swiper.isBeginning) {
            el.classList.add(CLASS_BEGIN);
            el.classList.remove(CLASS_END, CLASS_MIDDLE);
        } else {
            el.classList.remove(CLASS_BEGIN, CLASS_END);
            el.classList.add(CLASS_MIDDLE);
        }
    };

    componentDidMount(): void {
        this.setRenderSwiper();
        window.addEventListener('resize', this.setRenderSwiper);
    }

    componentDidUpdate(): void {
        if (!this.state.renderSlider) {
            this.setRenderSwiper();
        }
    }

    componentWillUnmount(): void {
        window.removeEventListener('resize', this.setRenderSwiper);
    }

    getCasinoFilters(isMobile = false): Array<Pick<CasinoFilterInterface, 'id' | 'name' | 'langs'>> {
        return [
            isMobile && {id: ELEMENT_NOT_FOUND, name: I18n.t('all_games')},
            ...this.props.casinoFilters,
            {id: CASINO_TAB_LOOTBOX, name: I18n.t('lootboxes')}
        ].filter(Boolean);
    }

    setRenderSwiper = (): void => {
        const sortingAz = getWidth('.sorting-az');
        const containerWidth = getWidth('.section-favourite');
        const gapWidth = 50;
        const filterList = getWidth('.buttons-filter-without-swiper') || getWidth('.swiper-wrapper');

        this.setState({renderSlider: filterList + sortingAz + gapWidth > containerWidth});
    };

    handleOpenCasinoMobileSheet = (e: React.MouseEvent<HTMLButtonElement>): void => {
        e.preventDefault();
        e.stopPropagation();

        const casinoFilters = this.getCasinoFilters(true);
        const {selectedFilterGroupId, onClick} = this.props;

        openCasinoMobileSheetPopup({
            onAfterRowSelect: onClick,
            renderRows: closeSheet => casinoFilters.map(filter => <FilterGroup
                className={`casino-mobile-sheet__row${filter.id === selectedFilterGroupId ? ' casino-mobile-sheet__row--active' : ''}`}
                id={filter.id}
                langs={filter.langs}
                onClick={closeSheet}
                name={filter.name}
                key={filter.id}
            />),
            title: I18n.t('filters')
        });
    };

    renderFavouriteSlide = (): React.ReactNode => {
        const {showOnlyFavorite, favoritesCount, handleButtonFavouriteClick} = this.props;
        return <SwiperSlide>
            <ButtonFavourite
                isActive={showOnlyFavorite}
                favoritesCount={favoritesCount}
                handleOnClick={handleButtonFavouriteClick}
            />
        </SwiperSlide>;
    };

    renderAllGamesSlide = (): React.ReactNode => {
        const {selectedFilterGroupId} = this.props;
        return <SwiperSlide>
            <FilterGroup
                className={`button-group-item${selectedFilterGroupId === ELEMENT_NOT_FOUND ? ' selected' : ''}`}
                id={ELEMENT_NOT_FOUND}
                onClick={this.props.onClick}
                name={I18n.t('all_games')}
            />
        </SwiperSlide>;
    };

    render(): React.ReactNode {
        const {selectedFilterGroupId, showOnlyFavorite, favoritesCount, handleButtonFavouriteClick} = this.props;
        const {renderSlider} = this.state;
        const showFiltersSheet = isCasinoFiltersSheetBreakpoint();
        const casinoFilters = !showFiltersSheet && this.getCasinoFilters();

        return showFiltersSheet
            ? <>
                <ButtonFavourite
                    isActive={showOnlyFavorite}
                    favoritesCount={favoritesCount}
                    handleOnClick={handleButtonFavouriteClick}
                />
                <button
                    type="button"
                    className="button-filter-select"
                    onClick={this.handleOpenCasinoMobileSheet}
                >
                    {I18n.t('filters')}
                </button>
            </>
            : <div className="casino-filter__row row-buttons">
                <div className={`${renderSlider ? 'buttons-casino-filter-slide' : ''}`} >
                    <div className={`buttons-filter-group ${renderSlider ? '' : 'without-swiper'}`} ref={this.rootElement}>
                        <ParentsFilter isSwiper={renderSlider} onCheckReached={this.onCheckReached}>
                            {this.renderAllGamesSlide()}
                            {this.renderFavouriteSlide()}
                            {casinoFilters && casinoFilters.map(filter => <SwiperSlide key={filter.id}>
                                <FilterGroup
                                    className={`button-group-item${filter.id === selectedFilterGroupId ? ' selected' : ''}`}
                                    id={filter.id}
                                    langs={filter.langs}
                                    onClick={this.props.onClick}
                                    name={filter.name}
                                />
                            </SwiperSlide>)}
                        </ParentsFilter>
                    </div>
                </div>
            </div>;
    }
}
